import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const IncludedFee = ({ data }) => {
  return (
    <>
      {data.map((item, index) => (
        <div
          key={index}
          className="row mb-4 justify-between last:mb-0 lg:mb-10"
        >
          <div className="col-12 self-center lg:col-6">
            <Title
              as="h2"
              className="bbc-title mb-4 text-center font-semibold text-bbc-brand-800 lg:mb-8 lg:text-left"
              text={item.title}
            />
            <ul
              className={"mx-4 mb-6 list-disc leading-bbc-26 lg:mx-0 lg:mb-0 "}
            >
              {item.contents.map((content, index) => (
                <li
                  key={index}
                  className="  relative mb-2 list-none pl-5  text-bbc-gray before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-[5px] before:w-[5px] before:rounded-full before:bg-bbc-gray before:content-['']"
                >
                  {content}
                </li>
              ))}
            </ul>
          </div>
          <div
            className={`col-12 text-center lg:col-6 ${
              item.positionImage === "left"
                ? "lg:order-first lg:text-left"
                : "order-last lg:text-right"
            }`}
          >
            <Img {...item.img} />
          </div>
        </div>
      ))}
    </>
  );
};

export default IncludedFee;

IncludedFee.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
};

IncludedFee.defaultProps = {
  data: [],
  children: <></>,
};
